// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
// import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup"; // Foundation
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import * as React from "react";

// Foundation --->
import CookiePrivacyPolicyPopup from "@store/Overrides/Components/CookiePrivacyPolicyPopup";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const enum fields {
    cookiePopupContent = "cookiePopupContent",
    cookieTitle = "cookieTitle",
}

interface OwnProps extends PageProps {
    fields: {
        [fields.cookiePopupContent]: string;
        [fields.cookieTitle]: string;
    };
}
// <--- Foundation

export interface FooterStyles {
    page?: MobiusPageProps;
}

export const footerStyles: FooterStyles = {
    page: {
        css: css`
            background-color: ${getColor("tertiary")};
            color: ${getColor("text.accent")};
        `,
    },
};

const styles = footerStyles;

const Footer = ({ id, fields: { cookiePopupContent, cookieTitle } }: OwnProps /* Foundation */) => (
    <Page as="footer" isFooter={true} {...styles.page}>
        <Zone contentId={id} zoneName="Content" />
        <CookiePrivacyPolicyPopup
            /* Foundation */
            content={cookiePopupContent}
            cookieTitle={cookieTitle}
        />
    </Page>
);

const pageModule: PageModule = {
    component: Footer,
    definition: {
        hasEditableTitle: false,
        hasEditableUrlSegment: false,
        pageType: "System",
        // Foundation --->
        fieldDefinitions: [
            {
                name: fields.cookiePopupContent,
                displayName: "Cookie Popup text",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.cookieTitle,
                displayName: "Cookie Title",
                editorTemplate: "TextField",
                defaultValue: "Cookie Policy",
                fieldType: "Translatable",
            },
        ],
        // <--- Foundation
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "Footer" instead of this constant.
 */
export const FooterContext = "Footer";
